<template>
  <div>
    <lazy-img v-if="!loading"
            :image-url="imageItem"
            :picture-class="pictureClass"
            alt="propertyUrl">
    </lazy-img>
  </div>
</template>

<script>
export default {
  props: {
    propertyId: Number,
    default: 0,
    fallbackUrl: String,
    pictureClass: String,
    divId: String,
    isPreview: Boolean,
    hideElement: Boolean
  },

  data () {
    return {
      supported: undefined,
      loading: true,
      // propertiesDefined : null,
      propertiesDefinedObject: {},
      idsIncluded: [],
      imageItem : this.fallbackUrl,
    }
  },

  mounted () {


    this.$nextTick(() => {
      this.getData();
      this.imageItem = this.recoverSourceProperty(this.propertyId) ;
    });
  },
  methods: {
    recoverSourceProperty (propertyId) {
      if (this.idsIncluded.includes(propertyId)) {
        return this.propertiesDefinedObject[propertyId].value
      } else {
        if (!this.isPreview && this.hideElement) {
          // console.log('Removing Html element')
          const divParent = document.getElementById(this.divId)
          divParent.remove()
        }
        return this.fallbackUrl
      }
    },
    getData () {
      const itemID = this.$store.getters.currentItemVariation.item.id;
      const variationProperties = this.$store.state.items[itemID].variation.documents[0].data.variationProperties;
      // console.log('ItemRecovered: ', itemID);
      // console.log('IsDefinedVariationProperties: ', variationProperties != undefined );
      if (variationProperties != undefined) {
        variationProperties.forEach((element, index) =>{
          if (variationProperties[index].properties != undefined) {
            variationProperties[index].properties.forEach(el => {
              this.propertiesDefinedObject[el.id] = { name: el.names.name, value: el.values.value };
              this.idsIncluded.push(el.id);
            })
          }
        });

         // TEST CONSOLE DIRECT
        // const itemID = ceresStore.getters.currentItemVariation.item.id;
        // const variationProperties = ceresStore.state.items[itemID].variation.documents[0].data.variationProperties;
        // let propertiesDefinedObject = {};
        // let idsIncluded = [];
        // if (variationProperties != undefined) {
        //   variationProperties.forEach((element, index) =>{
        //     if (variationProperties[index].properties != undefined) {
        //       variationProperties[index].properties.forEach(el => {
        //         propertiesDefinedObject[el.id] = { name: el.names.name, value: el.values.value };
        //         idsIncluded.push(el.id);
        //
        //       })
        //     }
        //
        //   });
        // }
        // console.log('VariationProperties', variationProperties);
        // console.log('IDS_included', idsIncluded);
        // console.log('Objecst_included', propertiesDefinedObject);


      }else{
        // console.log('Variation properties no definidos para este ITEM: ',itemID);
      }
      this.loading = false
    }
  }
}
</script>
